__turbopack_context__.v({
  "actions": "CShop-module__cz257W__actions",
  "actionsLeft": "CShop-module__cz257W__actionsLeft",
  "actionsRight": "CShop-module__cz257W__actionsRight",
  "actionsRow": "CShop-module__cz257W__actionsRow",
  "bottomGrid": "CShop-module__cz257W__bottomGrid",
  "buttonPrimary": "CShop-module__cz257W__buttonPrimary",
  "buttonSecondary": "CShop-module__cz257W__buttonSecondary",
  "deleteBtn": "CShop-module__cz257W__deleteBtn",
  "details": "CShop-module__cz257W__details",
  "discountBlock": "CShop-module__cz257W__discountBlock",
  "discountHint": "CShop-module__cz257W__discountHint",
  "discountInput": "CShop-module__cz257W__discountInput",
  "discountRemoveBtn": "CShop-module__cz257W__discountRemoveBtn",
  "discountRow": "CShop-module__cz257W__discountRow",
  "discountStatusError": "CShop-module__cz257W__discountStatusError",
  "discountStatusOk": "CShop-module__cz257W__discountStatusOk",
  "empty": "CShop-module__cz257W__empty",
  "fieldFull": "CShop-module__cz257W__fieldFull",
  "fieldsGrid": "CShop-module__cz257W__fieldsGrid",
  "fieldsGridPost": "CShop-module__cz257W__fieldsGridPost",
  "fieldsGridStreet": "CShop-module__cz257W__fieldsGridStreet",
  "freeDeliveryBanner": "CShop-module__cz257W__freeDeliveryBanner",
  "freeDeliveryOk": "CShop-module__cz257W__freeDeliveryOk",
  "freeDeliveryPending": "CShop-module__cz257W__freeDeliveryPending",
  "freeDeliveryThreshold": "CShop-module__cz257W__freeDeliveryThreshold",
  "item": "CShop-module__cz257W__item",
  "itemBusy": "CShop-module__cz257W__itemBusy",
  "lineSum": "CShop-module__cz257W__lineSum",
  "lineSumLabel": "CShop-module__cz257W__lineSumLabel",
  "lineSumValue": "CShop-module__cz257W__lineSumValue",
  "list": "CShop-module__cz257W__list",
  "loginPrompt": "CShop-module__cz257W__loginPrompt",
  "loginPromptHint": "CShop-module__cz257W__loginPromptHint",
  "loginPromptTitle": "CShop-module__cz257W__loginPromptTitle",
  "meta": "CShop-module__cz257W__meta",
  "metaItem": "CShop-module__cz257W__metaItem",
  "metaPriceBefore": "CShop-module__cz257W__metaPriceBefore",
  "name": "CShop-module__cz257W__name",
  "optionsBlock": "CShop-module__cz257W__optionsBlock",
  "optionsColumn": "CShop-module__cz257W__optionsColumn",
  "optionsEmpty": "CShop-module__cz257W__optionsEmpty",
  "optionsHeading": "CShop-module__cz257W__optionsHeading",
  "optionsHint": "CShop-module__cz257W__optionsHint",
  "optionsInfo": "CShop-module__cz257W__optionsInfo",
  "optionsItem": "CShop-module__cz257W__optionsItem",
  "optionsLabel": "CShop-module__cz257W__optionsLabel",
  "optionsLabelName": "CShop-module__cz257W__optionsLabelName",
  "optionsLabelPrice": "CShop-module__cz257W__optionsLabelPrice",
  "optionsList": "CShop-module__cz257W__optionsList",
  "orderCheckboxRow": "CShop-module__cz257W__orderCheckboxRow",
  "orderCompleteBody": "CShop-module__cz257W__orderCompleteBody",
  "orderCompleteHeading": "CShop-module__cz257W__orderCompleteHeading",
  "orderCompleteNotFound": "CShop-module__cz257W__orderCompleteNotFound",
  "orderCompleteNote": "CShop-module__cz257W__orderCompleteNote",
  "orderCompleteNotePaid": "CShop-module__cz257W__orderCompleteNotePaid",
  "orderCompletePaymentInfoDetails": "CShop-module__cz257W__orderCompletePaymentInfoDetails",
  "orderCompleteToPay": "CShop-module__cz257W__orderCompleteToPay",
  "orderForm": "CShop-module__cz257W__orderForm",
  "orderFormActions": "CShop-module__cz257W__orderFormActions",
  "orderFormActionsLeft": "CShop-module__cz257W__orderFormActionsLeft",
  "orderFormActionsRight": "CShop-module__cz257W__orderFormActionsRight",
  "orderGrid": "CShop-module__cz257W__orderGrid",
  "orderMain": "CShop-module__cz257W__orderMain",
  "orderSection": "CShop-module__cz257W__orderSection",
  "orderSectionHeading": "CShop-module__cz257W__orderSectionHeading",
  "orderSectionNumber": "CShop-module__cz257W__orderSectionNumber",
  "orderSummary": "CShop-module__cz257W__orderSummary",
  "orderSummaryLine": "CShop-module__cz257W__orderSummaryLine",
  "root": "CShop-module__cz257W__root",
  "step": "CShop-module__cz257W__step",
  "stepLink": "CShop-module__cz257W__stepLink",
  "stepName": "CShop-module__cz257W__stepName",
  "stepNr": "CShop-module__cz257W__stepNr",
  "stepper": "CShop-module__cz257W__stepper",
  "stepperBtn": "CShop-module__cz257W__stepperBtn",
  "stepperInput": "CShop-module__cz257W__stepperInput",
  "steps": "CShop-module__cz257W__steps",
  "summary": "CShop-module__cz257W__summary",
  "summaryDiscountValue": "CShop-module__cz257W__summaryDiscountValue",
  "summaryRow": "CShop-module__cz257W__summaryRow",
  "summaryTitle": "CShop-module__cz257W__summaryTitle",
  "summaryTotal": "CShop-module__cz257W__summaryTotal",
  "summaryTotalValue": "CShop-module__cz257W__summaryTotalValue",
  "summaryValue": "CShop-module__cz257W__summaryValue",
  "summaryVatNote": "CShop-module__cz257W__summaryVatNote",
  "tabButton": "CShop-module__cz257W__tabButton",
  "tabList": "CShop-module__cz257W__tabList",
  "tabPanel": "CShop-module__cz257W__tabPanel",
  "thumb": "CShop-module__cz257W__thumb",
  "variantRow": "CShop-module__cz257W__variantRow",
  "variantSwatch": "CShop-module__cz257W__variantSwatch",
  "variantSwatchImg": "CShop-module__cz257W__variantSwatchImg",
  "variantValueName": "CShop-module__cz257W__variantValueName",
  "variants": "CShop-module__cz257W__variants",
});
